import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Formik } from "formik";
import validationSchema from "./validation";
import Input from "../../../components/Input/index";
import Select from "../../../components/Select/index";
import Countries from "../../../utils/Countries";
import UploadFilesField from "../../../components/UploadFilesField/index";
import UploadImageField from "../../../components/UploadImageField/index";
import Textarea from "../../../components/Textarea/index";
import Checkbox from "../../../components/Checkbox/index";
import ValidatesFormWith from "../../../utils/ValidatesFormWith";
import {
  FREE_PLAN,
  FULL_PLAN,
  PRODUCERS_PLAN,
  VENUES_PLAN
} from "../../../constants";

class TheaterRegisterForm extends React.PureComponent {
  process = values => {
    const theater = {
      name: values.name,
      email: values.email,
      password: values.password,
      plan: values.plan,
      theaterName: values.theaterName,
      country: values.country,
      type: values.type,
      city: values.city,
      address: values.address,
      biography: values.biography,
      website: values.website,
      features: [],
      images: values.images,
      facebook: values.facebook
    };

    if (values.capacity) {
      theater.features.push({
        type: "text",
        key: "capacity",
        name: "Capacidad",
        value: values.capacity
      });
    }
    values.files.forEach(file => {
      let { name } = file;
      if ({}.hasOwnProperty.call(file, "description") && file.description) {
        name = file.description;
      }
      theater.features.push({
        type: "link",
        name,
        value: file.url
      });
    });

    this.props.onCreateTheater(theater);
  };

  render() {
    return (
      <Formik
        initialValues={{
          name: "",
          email: "",
          password: "",
          plan: this.props.plan,
          theaterName: "",
          website: "",
          address: "",
          city: "",
          country: "",
          biography: "",
          capacity: "",
          type: "",
          facebook: "",
          files: [],
          images: [],
          ToS: false
        }}
        onSubmit={this.process}
        validate={ValidatesFormWith(validationSchema)}
        validateOnChange={false}
        render={props => (
          <form onSubmit={props.handleSubmit} style={{ textAlign: "left" }}>
            {/* <div className="row">
              <div className="col-md-12">
                <h4 style={{ textAlign: "center" }}>Datos personales</h4>
              </div>
            </div> */}

            <div className="row">
              <div className="col-md-6">
                <Input label="Nombre" name="name" />
              </div>
              <div className="col-md-6">
                <Input label="Correo electrónico" name="email" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Input label="Contraseña" name="password" type="password" />
              </div>
              <div className="col-md-6">
                <Select
                  label="Plan"
                  name="plan"
                  placeholder="Selecciona tu plan"
                  options={[
                    { value: FREE_PLAN, label: "Gratis" },
                    { value: PRODUCERS_PLAN, label: "Producers" },
                    { value: VENUES_PLAN, label: "Venues" },
                    { value: FULL_PLAN, label: "Full" }
                  ]}
                />
              </div>
            </div>

            {/* <div className="row">
              <div className="col-md-12">
                <h4 className="mt-10" style={{ textAlign: "center" }}>
                  Datos del teatro o compañía
                </h4>
              </div>
            </div> */}

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <Input label="Nombre" name="theaterName" />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <Select
                    label="Tipo de institución"
                    name="type"
                    placeholder="Tipo de institución"
                    options={[
                      { value: "teather", label: "Teatro" },
                      { value: "company", label: "Compañía" },
                      { value: "festival", label: "Festival" },
                      { value: "producer", label: "Productor" }
                    ]}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <Select
                    label="País"
                    name="country"
                    placeholder="Seleccione país"
                    options={Countries}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <Input label="Ciudad" name="city" />
              </div>
              <div className="col-md-8">
                <Input label="Dirección" name="address" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                <Input label="Sitio web" name="website" />
              </div>
              <div className="col-md-4">
                <Input label="Número de butacas" name="capacity" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Input label="Facebook" name="facebook" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <UploadFilesField
                  doc
                  pdf
                  label="Archivos técnicos"
                  name="files"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <Textarea label="Biografía" name="biography" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <UploadImageField label="Imágenes" name="images" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <Checkbox
                  label="Términos y condiciones"
                  name="ToS"
                  error="Debes aceptar los términos y condiciones antes de registrarte"
                >
                  <Link to="/tos" className="tos-checkbox" target="_blank">
                    {" "}
                    Acepto los términos y condiciones
                  </Link>
                </Checkbox>
              </div>
            </div>

            <div className="m-b-md m-t-md">
              <button type="submit" className="book-btn">
                <span className="book-btn-l">
                  <i className="fa fa-save" />
                </span>
                <span className="book-btn-r">Registrarme</span>
                <div className="clear" />
              </button>
            </div>
          </form>
        )}
      />
    );
  }
}

TheaterRegisterForm.propTypes = {
  onCreateTheater: PropTypes.func
};

TheaterRegisterForm.defaultProps = {
  onCreateTheater: () => {}
};

export default TheaterRegisterForm;



// WEBPACK FOOTER //
// ./src/containers/General/TheaterRegisterPage/Form.js